module.exports = __webpack_public_path__ + "img/xk.332ae30c.svg";